import { render, staticRenderFns } from "./BorderChoice.vue?vue&type=template&id=709f935e&"
import script from "./BorderChoice.vue?vue&type=script&lang=js&"
export * from "./BorderChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheSelect: require('/web/components/TheSelect.vue').default})
